import { Add, Close } from '@mui/icons-material'
import { Box, Button, Chip, TextField, Typography, useTheme } from '@mui/material'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { StyledCard } from '../../../../../../../components/StyledCard'
import { AppDispatch } from '../../../../../../../store'
import { TechnologyActions, TechnologySelectors } from '../../../../../../../store/technology'

export const ProjectKeywords = () => {
  const theme = useTheme()
  const dispatch = useDispatch<AppDispatch>()

  const [newTag, setNewTag] = useState('')
  const [showAddTagField, setShowAddTagField] = useState(false)

  const selectedKeywords = useSelector(TechnologySelectors.makeSelectedKeywords)

  const handleAddKeyword = () => {
    const trimmedKeyword = newTag.trim()

    if (trimmedKeyword && !selectedKeywords.includes(trimmedKeyword)) {
      const updatedKeywords = [...selectedKeywords, trimmedKeyword]

      dispatch(TechnologyActions.updateSelectedKeywords(updatedKeywords))

      setNewTag('')
      setShowAddTagField(false)
    }
  }

  const handleDeleteKeyword = (keyword: string) => {
    const updatedKeywords: string[] = selectedKeywords.filter((k) => k !== keyword)
    dispatch(TechnologyActions.updateSelectedKeywords(updatedKeywords))
  }

  const handleAddTagButtonClick = () => {
    setShowAddTagField(true)
  }

  return (
    <StyledCard sx={{ p: 1.5 }}>
      <Typography fontSize="1.2rem" fontWeight={500} color="secondary">
        Keywords
      </Typography>

      <Box display="flex" flexDirection="row" flexWrap="wrap" alignItems="center" mt={1}>
        {selectedKeywords.map((keyword, index) => (
          <Chip
            key={index}
            label={keyword}
            component="div"
            variant="outlined"
            onDelete={() => handleDeleteKeyword(keyword)}
            deleteIcon={<Close />}
            sx={{
              m: 1,
              padding: '18px 8px',
              color: 'success.dark',
              borderColor: 'success.main',
              backgroundColor: 'success.light',
              fontWeight: theme.typography.fontWeightMedium,
              '& .MuiChip-deleteIcon': {
                display: 'none',
              },
              '&:hover .MuiChip-deleteIcon': {
                display: 'block',
              },
            }}
          />
        ))}
      </Box>
      <Box display="flex" justifyContent="flex-start" width="100%" mt={2}>
        {showAddTagField ? (
          <TextField
            type="text"
            size="medium"
            label="Add keyword"
            value={newTag}
            onChange={(e) => setNewTag(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                handleAddKeyword()
              }
            }}
            variant="outlined"
            sx={{ width: '100%' }}
          />
        ) : (
          <Button
            startIcon={<Add />}
            onClick={handleAddTagButtonClick}
            variant="outlined"
            color="primary"
            size="small"
            sx={{
              border: 'none',
              textTransform: 'capitalize',
              '&:hover': {
                border: 'none',
              },
            }}
          >
            Add keyword
          </Button>
        )}
      </Box>
    </StyledCard>
  )
}
